import { AcceptedFileConfig, FileTypeAccepted } from './accepted-file-config';
import { fromEvent, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export const fileValidator = (file: File, fileConfig: AcceptedFileConfig): Observable<FileValidatorResponse> => {

  const fileType = file.type;
  const fileSize = Math.round(file.size / 1024 / 1024); //byte to mb

  if (fileSize > fileConfig.fileMaxSizeMb) {
    return of({ isValid: false, error: 'tooLargeFileError', width: 0, height: 0 });
  }
  const isValid = fileConfig.fileTypeAccepted && fileConfig.fileTypeAccepted.includes(fileType as FileTypeAccepted);
  if (!isValid) {
    return of({ isValid, error: 'fileTypeError', width: 0, height: 0 });
  }
  const isAnImage = Array.isArray(fileConfig.fileTypeAccepted) ? fileConfig.fileTypeAccepted.join().includes('image') :
    fileConfig.fileTypeAccepted.includes('image');
  if (isAnImage && fileConfig.imgValidation) {
    const image = new Image();
    image.src = window.URL.createObjectURL(file);
    return fromEvent(image, 'load').pipe(
      map(_ => {
        const img = image;
        const imgWidth: number = img.width;
        const imgHeight: number = img.height;
        const configMinImgWidth = fileConfig.imgValidation.imgMinWidth;
        const configMinImgHeight = fileConfig.imgValidation.imgMinHeight;
        const configMaxImgWidth = fileConfig.imgValidation.imgMaxWidth;
        const configMaxImgHeight = fileConfig.imgValidation.imgMaxHeight;

        switch (fileConfig.imgValidation.imgWidthHeightPolicy) {
          case 'custom': {
            if (imgHeight < configMinImgHeight || imgHeight > configMaxImgHeight) {
              return {
                isValid: false,
                error: 'heightFileError',
                width: imgWidth,
                height: imgHeight
              };
            } else if (imgWidth < configMinImgWidth || imgWidth > configMaxImgWidth) {
              return {
                isValid: false,
                error: 'widthFileError',
                width: imgWidth,
                height: imgHeight
              };
            } else {
              return {
                isValid: true,
                width: imgWidth,
                height: imgHeight
              };
            }
          }
          case 'exactly': {
            if (imgHeight !== configMinImgHeight || imgWidth !== configMinImgWidth) {
              return {
                isValid: false,
                error: 'widthHeightFileError',
                width: imgWidth,
                height: imgHeight
              };
            } else {
              return {
                isValid: true,
                width: imgWidth,
                height: imgHeight
              };
            }
          }
          case 'max': {
            if (imgHeight > configMinImgHeight || imgWidth > configMinImgWidth) {
              return {
                isValid: false,
                error: 'widthHeightFileError',
                width: imgWidth,
                height: imgHeight
              };
            } else {
              return {
                isValid: true,
                width: imgWidth,
                height: imgHeight
              };
            }
          }
          case 'min': {
            if (imgHeight < configMinImgHeight || imgWidth < configMinImgWidth) {
              return {
                isValid: false,
                error: 'widthHeightFileError',
                width: imgWidth,
                height: imgHeight
              };
            } else {
              return {
                isValid: true,
                width: imgWidth,
                height: imgHeight
              };
            }
          }
        }
      })
    );
  } else {
    return of({ isValid: false, width: 0, height: 0 });
  }
};


export interface FileValidatorResponse {
  isValid: boolean;
  error?: FileValidationError;
  width: number;
  height: number;
}

export type FileValidationError =
  'tooLargeFileError'
  | 'widthHeightFileError'
  | 'fileTypeError'
  | 'widthFileError'
  | 'heightFileError';
